module.exports = "<!-- <div id=\"footer\">© COPYRIGHT 2017 PYRAMID IT CONSULTING ALL RIGHTS RESERVED.</div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_directive/footer/footer.component.html
// module id = ./src/app/sharedcomponents/_directive/footer/footer.component.html
// module chunks = main